import Banner from '../components/Banner.js';
import CorporateSolutionsSection from '../components/CorporateSolutionsSection.js';
import Form from '../components/Form.js'

const BulkDeal = () => {
    return (
        <>
            <div style={{ background: "linear-gradient(to right, #fff8f0, #f5f5f5)" }}>
                <Banner
                    image="https://cdn-gfion.nitrocdn.com/qvIRdRwwWxgjYTAsCpSSasYZiPnCVlIg/assets/images/optimized/rev-c156574/www.websolutions.co.uk/wp-content/uploads/2022/08/web-solutions-homepage-banner-clean-speed2.jpg"
                    heading="Corporate"
                />
                <CorporateSolutionsSection />
                <div className='d-md-flex d-block'>
                    <div className='w-100 w-md-50'> <Form /></div>

                    <div className='w-100 w-md-50 h-full d-flex'>
                        <div className="d-flex flex-column align-items-center justify-content-around rounded-4 p-4 h-full">
                            <div className="col-md-12 text-center text-md-start mb-4 mb-md-0">
                                <h2 className="fw-bold display-5 fs-3">Corporate Solutions</h2>
                                <p className="lead mt-3">
                                    Enhance your workplace and professional spaces with our bespoke corporate solutions.
                                    From elegant office décor to thoughtfully curated installations, we create environments
                                    that inspire and impress.
                                </p>
                                <p className="lead mt-3">
                                    Ideal for offices, hotels, guest houses, and corporate lounges, our solutions are tailored
                                    to align with your brand and ambiance.
                                </p>
                                <p className="lead mt-3">
                                    Partner with us to design and implement sophisticated solutions that elevate your corporate
                                    image and leave a lasting impression on clients and employees alike.
                                </p>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default BulkDeal;